import axios from 'axios'
import auth from '@/auth'
import store from '@/store'
import common from './common'
import HttpStatus, { getStatusText } from '@/components/http-status'
import { UniqError } from '@/classes'

function getCookie(name) {
  var value = '; ' + document.cookie
  var parts = value.split('; ' + name + '=')
  if (parts.length === 2) return parts.pop().split(';').shift()
}

const service = axios.create({
  baseURL: process.env.VUE_APP_WEBAPI_URI
})

service.getCookie = getCookie

service.interceptors.request.use(
  (config) => {
    setAuthHeader(config)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Add a response interceptor
service.interceptors.response.use(
  function (response) {
    common.setUnauthorized(false)
    return response
  },
  function (error) {
    store.dispatch('$resetSpinner')
    const status = error.response ? error.response.status : ''
    const statusText = error.response ? error.response.statusText : ''
    const url = error.response ? error.response.config.url : ''
    const errorCode = error.response?.data?.errorCode || ''
    console.log('Error in API call:', { status, statusText, url, errorCode })

    if (common.isExpiredToken(error)) {
      common.sentryLogError(error, 'isExpiredToken')
      common.setUnauthorized(true)
      common.refreshToken(error)
      // Reject with the original axios error so callers see error.response.status === 401
      // (e.g. the notification poll stops itself) instead of silently resolving to undefined.
      return Promise.reject(error)
    } else if (common.isInvalidToken(error)) {
      common.sentryLogError(error, 'isInvalidToken')
      common.setUnauthorized(true)
      auth.logout()
      return Promise.reject(error)
    }
    else if (error && (error.code === 'ERR_NETWORK' || error.code === 'ERR_BAD_REQUEST')) {
      common.sentryLogError(error, 'ERR_NETWORK_ERR_BAD_REQUEST')
      return Promise.reject(error)
    }
    else if (error && error.response && error.response.status && error.response.status === HttpStatus.INTERNAL_SERVER_ERROR) {
      let result = null
      if (error.response.data instanceof ArrayBuffer) {
        result = common.parseArrayBufferErrorResponse(error.response.data)
        const e = new UniqError(result.id || 0, result.message || statusText, status, '', result.message, errorCode)
        store.dispatch('errors/add', e)
      } else if (error.response.config.url.startsWith('/sms/unreadcount') || error.response.config.url.startsWith('/notifications/list')) {
        // Log error in console for polling API calls. Prevent on screen error spam
        common.sentryLogError(error, getStatusText(status))
        return Promise.reject(error)
      } else {
        result = error.response.data
        const e = new UniqError(result.id || 0, result.message || statusText, status, '', result.message, errorCode)
        store.dispatch('errors/add', e)
      }
      console.log('Internal Server Error processed:', getStatusText(status))
      common.sentryLogError(error, getStatusText(status))
      return Promise.reject(error)
    }
    else if (error && error.response && error.response.status && error.response.status === HttpStatus.CONFLICT) {
      // console.log(error.response)
      if (!error.response.config.url.startsWith('/quotes/')) {
        const e = new UniqError(0, statusText, status, url, error.response ? error.response.data : '', errorCode)
        store.dispatch('errors/add', e)
      }
      common.sentryLogError(error, getStatusText(status))
      return Promise.reject(error)
    }
    else {
      const e = new UniqError(0, statusText, status, url, error.response ? error.response.data : '', errorCode)
      store.dispatch('errors/add', e)
      common.sentryLogError(error, getStatusText(status))
      return Promise.reject(error)
    }
  }
)

/**
 * Set the Authorization header on a Axios Request.
 *
 * @param {Request} request The Axios Request instance to set the header on.
 * @return {void}
 */
function setAuthHeader(config) {
  const token = getCookie('UniqApi.Token')
  config.headers.Authorization = token ? 'Bearer ' + token : ''
}

/**
 * Retry the original request.
 *
 * Let's retry the user's original target request that had recieved a invalid token response
 * (which we fixed with a token refresh).
 *
 * @param {Request} request The Vue-resource Request instance to use to repeat an http call.
 * @return {Promise}
 */
// function _retry(config) {
//   return FqApi.request(config)
// }

/**
 * Refresh the access token
 *
 * Make an ajax call to the OAuth2 server to refresh the access token (using our refresh token).
 *
 * @private
 * @param {Request} request Vue-resource Request instance, the original request that we'll retry.
 * @return {Promise}
 */
// function _refreshToken(request) {
//   // return service.post('api/refresh_token', '=' + getCookie('UniqApi.Token'))
//   //   .then((result) => {
//   // self._storeToken(result)
//   // return self._retry(request)
//   // })
//   // .catch((error) => {
//   //   if (self._isInvalidToken(error)) {
//   auth.logout()
//   // }
//   // })
// }

/**
 * Check if the Vue-resource Response is an invalid token response.
 *
 * @private
 * @param {Response} response The Vue-resource Response instance received from an http call.
 * @return {boolean}
 */
// function _isInvalidToken(error) {
//   const status = error.response.status
//   const statusText = error.response.statusText
//   console.log(error)
//   console.log(`Invalid token ${status} ${statusText}`)
//   return (status === 401 && statusText === 'Invalid token')
// }

// function _isExpiredToken(error) {
//   const status = error.response.status
//   const statusText = error.response.statusText
//   console.log(error)
//   console.log(`Token expired ${status} ${statusText}`)

//   return (status === 401 && statusText === 'Token expired')
// }

export default service
